// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"37c6c67f","152":"d9fb09cc","309":"7f91c6a4","347":"b137f621","692":"44ef7ef0","721":"adf2a387","934":"5d1f55ac","937":"9f4f403d"}[chunkId] + ".chunk.js";
};